import { render } from "./PersonalInfo.vue?vue&type=template&id=998ff992&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"

import "./PersonalInfo.vue?vue&type=style&index=0&id=998ff992&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-998ff992"

export default script